/**
 * Builds the display lines of a German address: street on the first line,
 * "PLZ Stadt" on the second. Missing parts are dropped rather than rendered
 * as gaps, so a lone PLZ never produces a dangling separator.
 */
export function formatAddressLines(
  street: string | null | undefined,
  postalCode: string | null | undefined,
  cityName: string | null | undefined,
): string[] {
  const lines: string[] = [];

  if (street?.trim()) lines.push(street.trim());

  const cityLine = [postalCode?.trim(), cityName?.trim()]
    .filter(Boolean)
    .join(' ');
  if (cityLine) lines.push(cityLine);

  return lines;
}
